import * as joint from "jointjs";
import { withSvgTooltip } from "../tooltips";

export const removeTool = withSvgTooltip(
  new joint.elementTools.Button({
    markup: [
      {
        tagName: "circle",
        selector: "button",
        attributes: {
          cx: 10,
          cy: 10,
          r: 10,
          fill: "#FFFFFF",
          cursor: "pointer",
        },
      },
      {
        tagName: "path",
        attributes: {
          fill: "none",
          stroke: "black",
          "stroke-width": 2,
          "stroke-linecap": "round",
          transform: "translate(10 10)",
          d: "M -4 -4 L 4 4 M -4 4 L 4 -4",
          cursor: "pointer",
        },
      },
    ],
    useModelGeometry: true,
    y: "0%",
    x: "0%",
    offset: { x: -10, y: -10 },
    action: function () {
      // @ts-ignore
      this.model.remove();
    },
  }),
  "Delete (Delete/Backspace)",
);
